<template>
  <a
    v-if="href"
    :class="classObject()"
    :href="href"
    :target="extra ? '_blank' : ''"
    :rel="extra ? 'nofollow noopener noreferrer' : ''"
  >
    <span class="link-theme__icon icon" v-if="back">
      <back-svg />
    </span>
    <span class="link-theme__name">{{ name }}</span>
  </a>
  <button
    v-else
    :class="classObject()"
    type="button"
    role="button"
    :aria-label="label"
    @click="handleClick"
  >
     <span class="link-theme__icon icon" v-if="back">
      <back-svg />
    </span>
    <span class="link-theme__name">{{ name }}</span>
  </button>
</template>

<script>
import BackSvg from '../../../../../assets/img/icons/back-s.svg';

export default {
  name: 'linkTheme',
  components: {
    BackSvg,
  },
  props: {
    href: String,
    extra: Boolean,
    back: Boolean,
    name: String,
    label: String,
    uppercase: Boolean,
  },
  data() {
    return {
      isActive: false,
    };
  },
  computed: {},
  methods: {
    classObject() {
      return {
        'link-theme': true,
        'link-theme--back': this.back,
        'link-theme--uppercase': this.uppercase,
      };
    },
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/setup.scss';

$bg: rgba(0, 0, 0, 0.1);

.link-theme {
  position: relative;
  //padding: 6px 11px 4px 14px;
  padding: 6px 17.12px 4px 18px;
  width: fit-content;
  height: 22px;
  display: flex;
  align-items: center;
  font-family: $f-neutraBook;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 0.3px;
  white-space: nowrap;
  border: 1px solid $bg;
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;

  //@include up-tablet {
  //  padding: 6px 13px 4px 14px;
  //}

  @include hover {
    &::before {
      transform: scaleY(1);
      transform-origin: bottom center;
    }
  }

  &::before {
    @include pseudo();
    top: 0;
    left: -1px;
    z-index: 1;
    width: calc(100% + 2px);
    height: 100%;
    background: $bg;
    border-radius: 20px;
    transform: scaleY(0);
    transform-origin: top center;
    @include anim(transform, 0.4s, cubic-bezier(0.075, 0.82, 0.165, 1));
  }

  &--back {
    padding-right: 11px;
    padding-left: 4.4px;
  }

  &--uppercase {
    text-transform: uppercase;
  }

  span {
    position: relative;
    z-index: 2;
  }

  &__icon {
    margin-right: 1px;
    display: flex;
    width: 14px;
    height: 16px;

    svg {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
